/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
export class CarouselProvider {
    constructor() {
        this.config = {
            interval: 5000,
            pause: 'hover',
            wrap: true,
            keyboard: true
        };
    }
    $get() {
        return this.config;
    }
}
